// @flow
'use strict';

import { connect } from 'react-redux';

import BotaoOpcaoOperacaoNaoRealizada from './botao_opcao_operacao_nao_realizada';

export default connect<*, *, *, *, *, *>()(BotaoOpcaoOperacaoNaoRealizada);
